import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, MessageCircle } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToSection = (sectionId) => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const goHome = () => {
    setMobileMenuOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <header className="dark-header" data-testid="site-header">
      <div className="header-phone-strip" data-testid="phone-strip">
        <div className="phone-strip-inner">
          <a href="https://wa.me/6580179673?text=Hi%2C%20I'm%20exploring%20India%E2%80%93Singapore%20expansion.%20Would%20like%20to%20understand%20how%20Bizenntrum%20can%20help." target="_blank" rel="noopener noreferrer" className="phone-strip-item">
            <span className="corridor-dot corridor-dot--sg" aria-hidden="true" /> <MessageCircle size={11} /> <span>Singapore</span> +65 8017 9673
          </a>
          <span className="phone-strip-sep">|</span>
          <a href="https://wa.me/919000309533?text=Hi%2C%20I'm%20exploring%20India%E2%80%93Singapore%20expansion.%20Would%20like%20to%20understand%20how%20Bizenntrum%20can%20help." target="_blank" rel="noopener noreferrer" className="phone-strip-item">
            <span className="corridor-dot corridor-dot--in" aria-hidden="true" /> <MessageCircle size={11} /> <span>India</span> +91 90003 09533
          </a>
        </div>
      </div>
      <div className="header-content">
        <div className="header-brand" onClick={goHome} style={{ cursor: 'pointer' }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_sg-ind-experts/artifacts/puzsc844_bizzentrum%20b.png" 
            alt="Bizenntrum" 
            className="dark-logo"
          />
          <span className="header-brand-name">Bizenntrum</span>
        </div>
        
        <nav className="dark-nav desktop-nav">
          <button onClick={() => navigateToSection('services')} className="dark-nav-link">Services</button>
          <button onClick={() => navigateToSection('credibility')} className="dark-nav-link">About</button>
          <button onClick={() => navigateToSection('team')} className="dark-nav-link">Team</button>
          <button onClick={() => navigateToSection('resources')} className="dark-nav-link">Resources</button>
          <button onClick={() => navigateToSection('contact')} className="btn-primary" style={{ marginLeft: '16px' }}>
            Book a Strategy Call
          </button>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => navigateToSection('services')} className="mobile-nav-link">Services</button>
          <button onClick={() => navigateToSection('credibility')} className="mobile-nav-link">About</button>
          <button onClick={() => navigateToSection('team')} className="mobile-nav-link">Team</button>
          <button onClick={() => navigateToSection('resources')} className="mobile-nav-link">Resources</button>
          <button onClick={() => navigateToSection('contact')} className="btn-primary" style={{ width: '100%', marginTop: '12px' }}>
            Book a Strategy Call
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
